import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Drawer,
  IconButton,
  Box,
  List,
  ListItem,
  ListItemText,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
// OLD logo with white JPEG background:
// import Logo_ from "../../assets/logo.jpeg";

// Previous logo import:
// import Logo_ from "../../assets/logo-transparent.png";
import Logo_ from "../../assets/updated_hamsa_logo_transparent.png";
import becomeMemberServices from "../../services/becomeMemberServices";
import ByLawsServices from "../../services/ByLawsServices";
import { imageBaseURLProduction } from "../../services/api";
import proxyServices from "../../services/proxyServices";

const HeaderContainer = styled(Box)({
  width: "100%",
  height: '180px',
  // height: "max-content",
  position: "relative",
  backgroundColor: "#88A878",
});

const Logo = styled(Box)({
  // OLD:
  // backgroundColor: "transparent",

  // Match the desktop header background.
  backgroundColor: "#88A878",

  // position: 'absolute',
  // left: '20px',
  // top: '0',
  // zIndex: 2,
  "& img": {
    // width: '100%',
    height: "180px",
    display: "block",
  },
});

const GreenBar = styled(Box)({
  // OLD Ethiopian flag palette:
  // backgroundColor: "#008751",

  // PREVIOUS darker forest-green version:
  // backgroundColor: "#1F2A1C",

  backgroundColor: "#88A878",
  // padding: "12px 0",
  height: "60px",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& h1": {
    color: "white",
    fontSize: "24px",
    margin: 0,
    fontWeight: "500",
  },
});

const YellowBar = styled(Box)({
  // OLD Ethiopian flag palette:
  // backgroundColor: "#FFD700",

  // PREVIOUS darker forest-green version:
  // backgroundColor: "#2F3B2A",

  // Slightly lighter than the title area to separate the navigation row.
  backgroundColor: "#88A878",
  height: "60px",
  // Removed for the unified header design:
  // borderTop: "1px solid rgba(0,0,0,0.1)",
  // borderBottom: "1px solid rgba(0,0,0,0.1)",
  display: "flex",
  // justifyContent: 'space-between',
  justifyContent: "space-evenly",
  gap: "20px",
  alignItems: "center",
});

const YellowBarMobile = styled(Box)({
  // OLD Ethiopian flag palette:
  // backgroundColor: "#FFD700",

  // PREVIOUS darker forest-green version:
  // backgroundColor: "#2F3B2A",

  backgroundColor: "#88A878",
  height: "26px"

});

const NavList = styled("ul")({
  display: "none",
  "@media (min-width: 768px)": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    gap: "40px",
  },
  "@media (max-width: 1025px)": {

    "& li a": {
      // OLD nav text color:
      // color: "#000",
      color: "#F6EFE4",
      textDecoration: "none",
      fontSize: "12px !important",

      fontWeight: "600",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  listStyle: "none",
  margin: 0,
  padding: 0,
  "& li a": {
    // OLD nav text color:
    // color: "#000",
    color: "#F6EFE4",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "600",
    "&:hover": {
      // Forest-green palette hover accent
      color: "#C7D6AE",
      textDecoration: "underline",
    },
  },
});

const NavListMobile = styled("ul")({
  display: "none",
  "@media (max-width: 768px)": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    gap: "4px",
  },
  listStyle: "none",
  margin: 0,
  padding: 0,
  "& li a": {
    color: "#000",
    textDecoration: "none",
    fontSize: "6px",
    fontWeight: "600",
    "&:hover": {
      // Forest-green palette hover accent
      color: "#C7D6AE",
      textDecoration: "underline",
    },
  },
});

const RedBar = styled(Box)({
  // OLD Ethiopian flag palette:
  // backgroundColor: "#DC0000",
  // PREVIOUS darker version:
  // backgroundColor: "#3B4E32",
  backgroundColor: "#88A878",
  height: "60px",
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const RedBarMobile = styled(Box)({
  // OLD Ethiopian flag palette:
  // backgroundColor: "#DC0000",
  // PREVIOUS darker version:
  // backgroundColor: "#3B4E32",
  backgroundColor: "#88A878",
  // padding: "10px 0",
  color: "white",
  "@media (min-width: 768px)": {
    display: "none",
  },
});

const MobileMenuButton = styled(Box)({
  display: "flex",

  // OLD:
  // backgroundColor: "#fff",

  // Match the mobile header background so the logo blends in.
  backgroundColor: "#88A878",

  width: "100%",
  gap: 3,
  height: "max-content",
  alignItems: "stretch",

  "@media (min-width: 768px)": {
    display: "none",
  },
});

const Desktop = styled(Box)({
  display: "flex",
  width: "100%",
  height: "max-content",

  // OLD:
  // backgroundColor: "transparent",

  // Extend the header color behind the logo area
  // so the desktop header reads as one unified section.
  backgroundColor: "#88A878",

  "@media (max-width: 768px)": {
    display: "none",
  },
});

const StickyWrapper = styled(Box)({
  position: "sticky",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
  zIndex: 1100,
  backgroundColor: "#fff",
});

const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const goToTop = (event) => {
    event.preventDefault();
    navigate("/");

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    });
  };

  const goToSection = (event, sectionId) => {
    event.preventDefault();
    navigate(`/#${sectionId}`);

    const scrollToSection = () => {
      const section = document.getElementById(sectionId);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToSection);
    });

    setTimeout(scrollToSection, 300);
  };
  const [data, setData] = useState([]);
  const [byLaws, setByLaws] = useState([]);
  const [ProxyFoamData, setProxyFoamData] = useState([]);


  const getData = () => {
    becomeMemberServices
      .get()
      .then((res) => {
        console.log("---res---", res);
        setData(res?.data?.membershipInfo);
      })
      .catch(() => { });
  };
  const getByLawsData = () => {
    ByLawsServices
      .get()
      .then((res) => {
        console.log("---res---", res);
        setByLaws(res?.data?.data);
      })
      .catch(() => { });
  };
  const getProxyFoam = () => {
    proxyServices
      .get()
      .then((res) => {
        console.log("---res---", res);
        setProxyFoamData(res?.data?.data);
      })
      .catch(() => { });
  };


  useEffect(() => {
    getData();
    getByLawsData()
    getProxyFoam()
  }, []);

  console.log("data--header", data);

  return (
    <>
      <StickyWrapper>
        <Desktop>
        <Logo>
          <img src={Logo_} alt="Hamsa Lomi Logo" />
        </Logo>
        <HeaderContainer>
          <GreenBar>
            <h1 style={{ fontWeight: 800 }}>
              Hamsa Lomi Ethiopian Association
            </h1>
          </GreenBar>

          <YellowBar>
            <NavList sx={{ textWrap: "nowrap" }}>
              <li>
                <Link to="/" onClick={goToTop}>Home</Link>
              </li>
              <li>
                {/*
                  Old dedicated-page link kept for reference:
                  <Link to="/announcements">Announcements</Link>
                */}
                <Link
                  to="/#announcements"
                  onClick={(event) => goToSection(event, "announcements")}
                >
                  Announcements
                </Link>
              </li>
              <li>
                <Link
                  to="/#about"
                  onClick={(event) => goToSection(event, "about")}
                >
                  About Us
                </Link>
              </li>
              <li>
                {/*
                  Old dedicated-page link kept for reference:
                  <Link to="/board-members">Board Members</Link>
                */}
                <Link
                  to="/#boardMembers"
                  onClick={(event) => goToSection(event, "boardMembers")}
                >
                  Board Members
                </Link>
              </li>
              <li>
                <Link
                  to="/#gallery"
                  onClick={(event) => goToSection(event, "gallery")}
                >
                  Photo Gallery
                </Link>
              </li>
              <li>
                {/*
                  Old dedicated-page link kept for reference:
                  <Link to="/tributes">Tributes</Link>
                */}
                <Link
                  to="/#tribute"
                  onClick={(event) => goToSection(event, "tribute")}
                >
                  Tributes
                </Link>
              </li>
              <li>
                <Link
                  to="/#contact"
                  onClick={(event) => goToSection(event, "contact")}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <a
                  href={
                    Array.isArray(byLaws) && byLaws?.length > 0
                      ? imageBaseURLProduction + byLaws[0]?.file
                      : "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  By Laws
                </a>
              </li>
              <li>
                <Link to="/proxy-form" target="_blank" rel="noopener noreferrer">Proxy Form</Link>
              </li>
            </NavList>
          </YellowBar>

          <RedBar>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              px={2}
            >
              {/* <span>Phone: +1 555-555-5555</span> */}
              <Link
                to="/membership-application"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  // OLD mobile CTA colors:
                  // backgroundColor: "white",
                  // color: "#DC0000",
                  backgroundColor: "#F6EFE4",
                  color: "#1F2A1C",
                  padding: "8px 25px",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                }}
              >
                Become A Member
              </Link>
              {/* <span>Email: contact@hamsalomi.org</span> */}
            </Box>
          </RedBar>
        </HeaderContainer>
      </Desktop>

        <MobileMenuButton>
        <Box
          sx={{
            backgroundColor: "#88A878",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "64px",
            px: 0.5,
          }}
        >
          <img
            style={{
              height: "54px",
              width: "54px",
              display: "block",
              objectFit: "contain",
            }}
            src={Logo_}
            alt="Hamsa Lomi Logo"
          />
        </Box>


        <Stack width="100%" >
          <Box
            sx={{
              // OLD Ethiopian flag palette:
              // backgroundColor: "#008751",

              // PREVIOUS darker forest-green version:
              // backgroundColor: "#1F2A1C",

              backgroundColor: "#88A878",
              display: "flex",
              p: 1,
              justifyContent: "space-between",
              alignItems: "center",
              height: "30px",
            }}
          >
            <h5 style={{ color: "white" }}>Hamsa Lomi Ethiopian Association</h5>
            <MenuIcon
              onClick={() => setDrawerOpen(true)}
              sx={{ color: "white", ml: 1 }}
            // size={28}
            />
          </Box>
          <YellowBarMobile>
            {/* <NavListMobile>
          <li>
            <a href="#">Home</a>
          </li>
          <li>
            <a href="#announcements">Announcements</a>
          </li>
          <li>
            <a href="#about">About Us</a>
          </li>
          <li>
            <Link to="/board-members">Board Members</Link>
          </li>
          <li>
            <a href="#gallery">Photo Gallery</a>
          </li>
          <li>
            <Link to="/tributes">Tributes</Link>
          </li>
          <li>
            <a href="#contact">Contact Us</a>
          </li>
          <li>
            <a
                href={
                  Array.isArray(byLaws) && byLaws?.length > 0
                    ? imageBaseURLProduction + byLaws[0]?.file
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                By Laws
              </a>
          </li>
        </NavListMobile> */}
          </YellowBarMobile>
          <RedBarMobile>
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              alignItems="center"
              px={2}
            >
              {/* <h6>Phone: +1 555-555-5555</h6> */}

              <Link
                to="/membership-application"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  // OLD mobile CTA colors:
                  // backgroundColor: "white",
                  // color: "#DC0000",
                  backgroundColor: "#F6EFE4",
                  color: "#1F2A1C",
                  padding: "4px 12px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                }}
              >
                Become A Member
              </Link>
              {/* <h6>Email: contact@hamsalomi.org</h6> */}
            </Box>
          </RedBarMobile>
        </Stack>
      </MobileMenuButton>
      </StickyWrapper>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          width="250px"
          role="presentation"
          onClick={() => setDrawerOpen(false)}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton
              aria-label="Close mobile menu"
              onClick={() => setDrawerOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {[
              { text: "Home", link: "/", isRoute: true },
              // Old dedicated-page route kept for reference:
              // { text: "Announcements", link: "/announcements", isRoute: true },
              { text: "Announcements", link: "/#announcements", isRoute: true },
              { text: "About Us", link: "/#about", isRoute: true },
              // Old dedicated-page route kept for reference:
              // { text: "Board Members", link: "/board-members", isRoute: true },
              { text: "Board Members", link: "/#boardMembers", isRoute: true },
              { text: "Photo Gallery", link: "/#gallery", isRoute: true },
              // Old dedicated-page route kept for reference:
              // { text: "Tributes", link: "/tributes", isRoute: true },
              { text: "Tributes", link: "/#tribute", isRoute: true },
              { text: "Contact Us", link: "/#contact", isRoute: true },
            ].map(({ text, link, isRoute }) => (
              <ListItem
                key={text}
                button
                component={Link}
                to={link}
              >
                <ListItemText primary={text} />
              </ListItem>
            ))}
            <ListItem>
              <a
                href={
                  Array.isArray(byLaws) && byLaws?.length > 0
                    ? imageBaseURLProduction + byLaws[0]?.file
                    : "#"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                By Laws
              </a>
            </ListItem>
            <ListItem button component={Link} to="/proxy-form" target="_blank" rel="noopener noreferrer">
              <ListItemText primary="Proxy Form" />
            </ListItem>
          </List>

        </Box>
      </Drawer>
    </>
  );
};

export default Header;
